// frontend/src/api/zones.js
import { apiClient } from './index';

const zonesApi = {
  /**
   * Get all LGAs for dropdowns (Admin only)
   */
  getAllLgas: async () => {
    return await apiClient.get('/zones/lgas');
  },

  /**
   * Get all defined zones (Admin only)
   */
  getAllZones: async () => {
    return await apiClient.get('/zones/');
  },

  /**
   * Create a new zone (Admin only)
   * @param {Object} zoneData - { zone_name, lga_id, description, is_active }
   */
  createZone: async (zoneData) => {
    return await apiClient.post('/zones/', zoneData);
  },

  /**
   * Update an existing zone (Admin only)
   * @param {string} zoneId
   * @param {Object} updateData - { zone_name, description, is_active }
   */
  updateZone: async (zoneId, updateData) => {
    return await apiClient.put(`/zones/${zoneId}`, updateData);
  },

  /**
   * Delete a zone (Admin only)
   * @param {string} zoneId
   */
  deleteZone: async (zoneId) => {
    return await apiClient.delete(`/zones/${zoneId}`);
  },
};

export { zonesApi };